import $ from "jquery";
import scrollToAccordion from "./scroll-to-accordion";

$(document).ready(() => {
  scrollToAccordion(".js-lifecycle-item");
});
